<template>
  <div>
    <a-form :form="form" :label-col="{ span: 8 }" :wrapper-col="{ span: 24 }">
      <div id="myCal">
        <!-- 保费试算 -->
        <div class="title_">
          <div class="cutleft_ order">保费试算</div>
          <div class="cutleft_ policy">险种信息</div>
          <div class="cutoff_"></div>
        </div>
        <a-row class="changeStyle_">
          <a-col :span="18">
            <a-form-item :label-col="{ span: 3 }" label="计划" :wrapper-col="{ span: 21 }">
              <a-radio-group :disabled="disabledAll" v-model="plan">
                <a-radio-button :value="item.value" :key="item.value" v-for="item in planList">
                  {{ item.name }}
                </a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :offset="2" :span="4" class="calRight_">
            <div class="calTxt_">保费合计</div>
            <div class="calmoney_">¥ {{ totalPremium }}</div>
          </a-col>
        </a-row>
      </div>
      <div class="risk_">
        <div class="flex_">
          <div class="form_item">
            <a-form-item :label-col="{ span: 10 }" label="累计赔偿限额">
              <a-input disabled style="width: 280px" :value="planList[planIdx].money1" placeholder="累计赔偿限额" />
            </a-form-item>
          </div>
          <div class="form_item">
            <a-form-item :label-col="{ span: 10 }" label="每次事故赔偿限额">
              <a-input disabled style="width: 280px" :value="planList[planIdx].money2" placeholder="每次事故赔偿限额" />
            </a-form-item>
          </div>
          <div class="form_item">
            <a-form-item :label-col="{ span: 10 }" label="每人每次事故赔偿限额">
              <a-input disabled style="width: 280px" :value="planList[planIdx].money3" placeholder="每人每次事故赔偿限额" />
            </a-form-item>
          </div>
          <div class="form_item">
            <a-form-item :label-col="{ span: 10 }" label="每人每次医疗限额">
              <a-input disabled style="width: 280px" :value="planList[planIdx].money4" placeholder="每人每次医疗限额" />
            </a-form-item>
          </div>
        </div>
        <div class="btn_list">
          <a-button style="margin-bottom: 50px" class="calBtn_" type="primary" v-if="!agreementRead" @click="goplicy" :disabled="disabledAll">去投保</a-button>
        </div>
      </div>
    </a-form>
  </div>
</template>

<script>
import { riskinfoMixin } from '@/mixins/riskinfoMixin.js';
let DATA = require('../data').default;
export default {
  mixins: [riskinfoMixin],
  data() {
    return {
      form: {},
      plan: '',
      planList: DATA.plansValues, //计划列表
    };
  },
  computed: {
    //总保费
    totalPremium() {
      let money = 0;
      switch (this.plan) {
        case 'P04014D01':
          money = '3000';
          break;
        case 'P04014D02':
          money = '5000';
          break;
        case 'P04014D03':
          money = '7500';
          break;
      }
      return money;
    },
    planIdx() {
      let idx = 0;
      this.planList.forEach((item, i) => {
        if (item.value == this.plan) {
          idx = i;
        }
      });
      return idx;
    },
  },
  watch: {},
  props: ['disabledAll'],
  created() {
    const { u, p, planCode } = this.$route.query;
    this.creator = u;
    this.productCode = p;
    this.plan = planCode;
    this.userParams = {
      //从地址中获取
      userId: u,
      productCode: p,
    };
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    // 去投保
    goplicy() {
      this.$store.commit('setAgreement', true);
    },
  },
};
</script>

<style lang="scss" scoped>
.policy {
  display: none;
}

.calTxt_ {
  font-size: 18px !important;
  font-weight: bold !important;
  color: #666666;
}
.pre-box {
  margin-top: 15px;
}
.form_items {
  display: flex;
  width: 100%;
  color: #333;
  margin-bottom: 10px;
}
.risk_ {
  width: 60%;
}
.btn_list {
  margin-top: 20px;
  display: flex;

  .calBtn_ {
    margin-right: 30px;
  }
}
.flex_ {
  display: flex;
  flex-wrap: wrap;
}
.form_item {
  display: flex;
  justify-content: space-between;
  width: 100%;
  color: #333;
  margin-bottom: 10px;

  &.width_50 {
    width: 50%;
  }

  &.width_40 {
    width: 40%;
  }

  &.width_60 {
    width: 60%;
  }

  > label {
    white-space: nowrap;
    margin-right: 10px;
    margin-top: 15px;
  }

  .right_ {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;

    .select_ {
      margin-top: 10px;
    }

    .check_item {
      display: flex;
      align-items: center;
      margin-right: 10px;
      margin-top: 10px;

      &.on {
        label {
          border-color: #fe8f2d;
        }
      }

      label {
        // border: 1px solid #d9d9d9;
        padding: 3px 10px;
        border-radius: 3px;
        margin-right: 5px;
      }

      &.s_input input {
        width: 50px;
      }

      input {
        width: 150px;
        margin-right: 5px;
      }
    }
  }
}
.p-header {
  width: 100%;
  font-weight: bold;
  font-size: 15px;
  margin-bottom: 0;
}

.form_item {
  margin-bottom: 0;
  .ant-form-item {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
}
.aftertext {
  position: relative;
}
.aftertext::after {
  content: '500000元起保';
  position: absolute;
  color: #999999;
  top: 10px;
  right: 30px;
  z-index: 2;
}
.tiaokuan_list {
  line-height: 24px;
}
</style>